// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3U0sp","author":"Table_author__1YEhh","authorImage":"Table_authorImage__LzIKE","unreadRow":"Table_unreadRow__1K0fP"};